<script lang="ts" setup></script>
<template>
  <button
    type="button"
    :aria-label="$t('Zavrieť okno pre vyhľadávanie')"
  >
    <svg
      aria-hidden="true"
      class="d-block"
      width="15"
      height="15"
    >
      <use xlink:href="#times" />
    </svg>
  </button>
</template>
